<style lang="less">
  @import "./NoImei.less";
</style>

<template>
  <div class="no-imei">
    <!--<p>您未绑定设备，请用微信扫码绑定设备</p>-->
    <!--<div class="page-btn">-->
      <!--<van-button type="info" size="large" @click="bindDeviceFn">微信扫码</van-button>-->
      <!--<van-button type="info" size="large" plain @click="bindDeviceFn">退出系统</van-button>-->
    <!--</div>-->
  </div>
</template>

<script>
import NoImei from './NoImei.js'
export default {
  ...NoImei
}
</script>
